// Core
import React, { Component } from 'react';

// Components
import { GECKO_CONSTS, GeckoBtn, GeckoFields } from '@geckolabs/gecko-react-ui';

import { ENABLED, MATCH } from '../../../../Logic/Account/featureFilter';

export default class FeatureFilterRow extends Component {

    constructor(props) {
        super(props);
        this.handleFieldChange = this.handleFieldChange.bind(this);
    }

    handleFieldChange(key, value) {
        this.props.onChange(this.props.index, key, value);
    }

    fields() {
        const group = this.props.group;
        const multi = group.features && group.features.length > 1;

        return [
            {
                key: 'features',
                label: 'Features',
                type: GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
                width: '100%',
                optionValueKey: 'value',
                optionsLabelKey: 'label',
                options: this.props.featureOptions || [],
                required: true,
                config: {
                    clearable: true,
                    placeholder: 'Select features…',
                },
            },
            {
                key: 'match',
                label: 'Match',
                type: GECKO_CONSTS.FIELD_TYPE_SELECT,
                width: '50%',
                optionValueKey: 'value',
                optionsLabelKey: 'label',
                options: [
                    { label: 'All selected (AND)', value: MATCH.ALL },
                    { label: 'Any selected (OR)', value: MATCH.ANY },
                ],
                required: true,
                config: { clearable: false },
                hideWhen: () => !multi,
            },
            {
                key: 'enabled',
                label: 'State',
                type: GECKO_CONSTS.FIELD_TYPE_SELECT,
                width: multi ? '50%' : '100%',
                optionValueKey: 'value',
                optionsLabelKey: 'label',
                options: [
                    { label: 'Enabled', value: ENABLED.ON },
                    { label: 'Disabled', value: ENABLED.OFF },
                ],
                required: true,
                config: { clearable: false },
            },
        ];
    }

    render() {
        const { index, group, canRemove, onRemove } = this.props;

        return (
            <div className="featureFilter-row">
                <div className="featureFilter-row-header">
                    <span className="featureFilter-row-title">Filter {index + 1}</span>
                    {canRemove && (
                        <GeckoBtn
                            name="Remove"
                            className="btn-default btn-sm"
                            handler={onRemove}
                        />
                    )}
                </div>
                <GeckoFields
                    fields={this.fields()}
                    values={group}
                    handler={this.handleFieldChange}
                />
            </div>
        );
    }
}
